import { handleActions } from "redux-actions";
import { customerTypeOptions, typeOptions } from "../constants";
import {
  SET_LOADING,
  SET_UPDATING,
  SET_FILTERS_DIRTY,
  SET_FILTERS_LOADING,
  SET_LOADING_FILTER_KEY,
  UPDATE_FILTER,
  UPDATE_FILTER_OPTIONS,
  UPDATE_DATA_SUCCESS,
  RESET_FILTERS_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  FETCH_INITIAL_DATA_SUCCESS
} from "./prospectsAndCustomersSagas";

const defaultSelectedFilters = {
  type: typeOptions[0],
  customerTypes: customerTypeOptions
};

const initialState = {
  isLoading: true,
  isUpdating: false,
  isFiltersLoading: false,
  loadingFilterKey: null,
  initialRequest: false,
  filtersDirty: false,
  filterOptions: {},
  selectedFilters: { ...defaultSelectedFilters },
  metrics: []
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATING]: (state, action) => ({
      ...state,
      isUpdating: action.payload
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      isFiltersLoading: action.payload
    }),
    [SET_LOADING_FILTER_KEY]: (state, action) => ({
      ...state,
      loadingFilterKey: action.payload
    }),
    [FETCH_INITIAL_DATA_SUCCESS]: (state, action) => ({
      ...state,
      initialRequest: true,
      currentUser: action.payload
    }),
    [FETCH_FILTERS_SUCCESS]: (state, { payload }) => ({
      ...state,
      filterOptions: { ...state.filterOptions, ...payload },
      selectedFilters: {
        ...state.selectedFilters,
        ...payload
      }
    }),
    [UPDATE_FILTER]: (state, { payload: { key, value } }) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        [key]: value
      }
    }),
    [UPDATE_FILTER_OPTIONS]: (state, { payload: { key, value } }) => ({
      ...state,
      filterOptions: {
        ...state.filterOptions,
        [key]: value
      }
    }),
    [UPDATE_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      metrics: payload
    }),
    [RESET_FILTERS_SUCCESS]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: { ...defaultSelectedFilters, ...state.filterOptions }
    })
  },
  initialState
);
